export default {
  INVESTOR_GOAL_PAUSE_TRACKING_REASON_REPOSITORY: Symbol.for('INVESTOR_GOAL_PAUSE_TRACKING_REASON_REPOSITORY'),
  CREATE_INVESTOR_GOAL_PAUSE_TRACKING_REASON_COMMAND: Symbol.for('CREATE_INVESTOR_GOAL_PAUSE_TRACKING_REASON_COMMAND'),
};
